// The one channel between the shell and its modules. Shapes are in types.js.

import { createContext, useContext } from 'react'

/** @type {React.Context<import('./types').TableContextValue|null>} */
export const TableContext = createContext(null)

/** @returns {import('./types').TableContextValue} */
export const useTable = () => {
  const value = useContext(TableContext)
  if (!value) throw new Error('useTable must be called inside a MeTable')
  return value
}
